export default __webpack_public_path__ + "static/media/drag-drop.dd83f95d.svg";